<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-card v-on:keyup.enter="buildNewSearch">
			<v-layout row justify-center align-center>
				<v-flex xs2/>
				<v-flex xs3>
					<v-text-field
						label="Nr oferty"
						class="ma-2"
						aria-label="offer code"
						browser-autocomplete="off"
						v-model="searchFields.code">
					</v-text-field>
				</v-flex>
				<v-flex xs5>
					<v-autocomplete
						clearable
						class="ma-2"
						v-model="searchFields.contestName"
						label="Nazwa konkursu"
						:items="contestNameList"
						aria-label="label for text"
					></v-autocomplete>
				</v-flex>
				<v-flex xs2/>
			</v-layout>
			<v-layout row justify-center align-center>
				<v-flex xs2/>
				<v-flex xs2>
					<v-select
						class="ma-2"
						v-model="searchFields.realizationYear"
						:items="realizationYears"
						label="Rok realizacji"
						clearable
						aria-label="realization year"
					></v-select>
				</v-flex>
				<v-flex xs3>
					<v-select
						class="ma-2"
						v-model="searchFields.status"
						:items="statusList"
						label="Status oferty"
						item-text="statusPL"
						item-value="statusEN"
						clearable
						aria-label="offer status"
					></v-select>
				</v-flex>
				<v-flex xs3>
					<v-layout align-center justify-center>
						<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
						<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
						<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
					</v-layout>
				</v-flex>
				<v-flex xs2/>
			</v-layout>
		</v-card>
		<v-card>
			<v-data-table
				:headers="headers"
				:rows-per-page-items="[10,20,25]"
				:items="offers"
				:pagination.sync="pagination"
				:total-items="itemCount"
				class="elevation-1">
				<template v-slot:items="props">
					<tr :class="{ 'primary--text': props.item.mutualOffer }">
					<td>
						<v-layout row>
							<v-flex shrink>
								{{ props.item.title }}
							</v-flex>
							<v-flex v-if="props.item.mutualOffer" pl-1 grow>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon v-on="on">groups</v-icon>
									</template>
									<div>
										<div>Oferent główny: {{ props.item.mainBidderName }}</div>
										<div>Oferta wspólna z: {{ props.item.mutualBidderNames.join(", ") }}</div>
									</div>
								</v-tooltip>
							</v-flex>
						</v-layout>
					</td>
					<td>{{ props.item.code }}</td>
					<td>{{ props.item.contestName }}</td>
					<td>{{ props.item.realizationYear }}</td>
					<td>{{ getStatusName(props.item) }}
						<span class="ml-1" v-if="props.item.status === 'AWAITING_CORRECTION'">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="18" color="blue" dark v-on="on">mail_outline</v-icon>
								</template>
								<div>
									<div>
										<b>{{ props.item.correctionCause }}</b>
									</div>
									<div>
									{{ props.item.detailedCorrectionCause }}
									</div>
									<div v-if="props.item.correctionDeadline">
									Termin poprawy: {{ props.item.correctionDeadline }}
									</div>
								</div>
							</v-tooltip>
						</span></td>
					<td align="center">
						<v-icon v-if="onlyMine" small class="mr-2" @click="editOffer(props.item)"
							:disabled="!editAllowed(props.item)"
							title="Edycja">edit
						</v-icon>
						<v-icon small class="mr-2" @click="viewOffer(props.item)" title="Podgląd">description</v-icon>
						<div v-if="!onlyMine">
							<v-icon
								v-for="project in props.item.projects" :key="project.projectId"
								small
								class="mr-2"
								@click="viewProjectSummary(project)"
								:title="'Podsumowanie projektu ' + project.projectName">
								ballot
							</v-icon>
						</div>
						<egranty-icon-button v-if="previewFinalEvaluationAllowed(props.item)" icon="content_paste_search" color="primary"
						label="Zobacz opinię końcową"
						@click="previewFinalEvaluation(props.item)"
						class="mr-2"
					></egranty-icon-button>
						<egranty-icon-button
								class="mr-2"
               				 	v-if="props.item.usernameCanManage"
                				icon="info"
                				small
                				:label="showCanManageOfferUserText(props.item)"
              		/>
					</td>
					</tr>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
	import {Api} from "@/api";
	import {Pagination} from "@/utils/PaginationUtils";
	import {Offer} from "@/api/generated/Offer";
	import {ContestRealizationYear} from "@/api/generated/ContestRealizationYear";
  import {Filters} from "@/utils/Filters";
  import {ExportUtils} from "@/utils/ExportUtils";
  import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";


	export default {
		name: "BidderOfferList",
		components: {EgrantyIconButton},

    mixins: [Filters],

		props: {
			onlyMine: {type: Boolean, default: true, required: false}
		},

		created() {
			this.loadMyOffersContestNames();
			this.loadRealizationYears();
			this.loadUserId();
      this.searchFields = this.retrieveFilters(this.searchFields);
      this.pagination = this.retrievePagination(this.pagination);
		},

		data () {
			return {
				searchFields: Pagination.initSearchedFields([
					"bidderId",
					"contestName",
					"status",
					"code",
					"realizationYear"
				]),
				headers: [
					{text: "Nazwa oferty", value: "title", sortable: true},
					{text: "Numer oferty", value: "code", sortable: true},
					{text: "Nazwa konkursu", value: "contestName", sortable: true},
					{text: "Rok realizacji", value: "realizationYear", sortable: true},
					{text: "Status oferty", value: "status", sortable: false},
					{text: "Akcje", align: "center", value: "action", sortable: false},
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
				offers: [],
				contestNameList: [],
				realizationYears: [],
				search: "",
				statusList: [
					{statusPL: "Nowa", statusEN: "NEW"},
					{statusPL: "Wysłana", statusEN: "SUBMITTED"},
					{statusPL: "Odrzucona", statusEN: "REJECTED"},
					{statusPL: "Oczekuje na poprawki", statusEN: "AWAITING_CORRECTION"},
					{statusPL: "Oczekuje na akceptację", statusEN: "AWAITING_MAIN_BIDDER_ACCEPTANCE"},
					{statusPL: "Oczekuje na akceptację współoferentów", statusEN: "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE"},
					{
						statusPL: "Oczekuje na akceptację zmian",
						statusEN: "POST_CORRECTION_MAIN",
					},
					{
						statusPL: "Oczekuje na akceptację zmian przez współoferenta",
						statusEN: "POST_CORRECTION_MUTUAL",
					},
					{statusPL: "Opiniowana", statusEN: "PROCESSED"}, // nie jest to faktyczny status na bazie
					{statusPL: "Rezerwowa", statusEN: "RESERVED"},
					{statusPL: "Finansowana", statusEN: "FINANCED"},
					{statusPL: "Niefinansowana", statusEN: "NOT_FINANCED"},
					{statusPL: "Realizowana", statusEN: "APPROVED"},
				],
				userId: null,
			};
		},

		computed: {
			userBidderId() {
				return this.onlyMine ? this.userId : this.$route.params.bidderId;
			}
		},

		watch: {
			"pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			}
		},

		methods: {
			showCanManageOfferUserText(offer){
      			return "Użytkownik " + offer.usernameCanManage + " aktualnie zarządza ofertą";
    		},
			buildNewSearch () {
				this.search = this.buildSearch();
				this.getItemList();
			},

			buildSearch () {
				if (!this.onlyMine) {
					this.searchFields.bidderId = this.$route.params.bidderId;
					return Pagination.buildSearchCriteria(this.searchFields, true);
				} else {
					return Pagination.buildSearchCriteria(this.searchFields, true);
				}
			},

      exportData() {
        let search = this.search;
        let sort = this.buildSort();
        let path = "/bidder-offers/export?search=" + search + "&sort=".concat(sort);
        ExportUtils.sendExportRequest(path, this);
      },

	  loadUserId() {
		Api.get(this, "/user/user-info", successResponse => {
			this.userId = successResponse.id;
		}, errorResponse => {
			this.$messagesBus.$emit("error", "Nie udało się załadować danych!", errorResponse);
		});
	  },

			getItemList () {
				if (this.search === "") {
					this.search = this.buildSearch();
				}
				let sort = this.buildSort();
				Api.get(this,
					"/bidder-offers/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.offers = response.itemList;
							this.itemCount = response.itemCount;
						});
			},
			buildSort() {
				let order = this.pagination.descending === true ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			editAllowed(offer) {
				return offer.editAllowed;
			},
			previewFinalEvaluationAllowed(item){
				if(item.bidderPreviewEnabled && (this.roles.isSubBidder() || this.roles.isBidder())){
					return true;
				}
				return false;
			},

			editOffer (offer) {
				this.$router.push("/app/contest/" + offer.contestId + "/place-offer/" + offer.id);
			},

			viewOffer (offer) {
				this.$router.openInNewTab("/view/contest/" + offer.contestId + "/offer/" + offer.id);
			},

      viewProjectSummary (item) {
        this.$router.push("/app/project/" + item.projectId + "/summary");
      },
	previewFinalEvaluation(offer) {
				Offer.getFinalEvaluationId(this, offer.id, response => {
					this.$router.push("/app/contest/" + offer.contestId + "/final-evaluation-peek/" + response);
				});
			},

			getStatusName (item) {
				let status = item.status;
				if(item.offerProcessed){
					return "Opiniowana";
				}
				return this.statusList.find(item => item.statusEN === status).statusPL;
			},

			async resetSearch () {
				await Pagination.resetSearch(this.searchFields);
				this.search = "";
				this.getItemList();
			},

			loadMyOffersContestNames () {
				if (this.onlyMine) {
					Offer.getAllContestNames(this, true, successResponse => {
							this.contestNameList = successResponse;
						},
						errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
						});
				} else {
					Offer.getBiddersContestNames(this, this.$route.params.bidderId, successResponse => {
						this.contestNameList = successResponse;
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
					}
					);
				}
			},

			loadRealizationYears () {
				ContestRealizationYear.getList(this,
					successResponse => {
						this.realizationYears = successResponse.items.map(x => x.value).sort((a, b) => a - b);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się wczytać lat realizacji", errorResponse);
					});
			},
		},
	};
</script>

<style scoped>

</style>
